import { combineReducers } from "redux";
import * as c from "./constant";
import { Map } from "immutable";

function cards(state = [], action) {
  switch (action.type) {
    case c.SET_CARDS:
      return action.cards;
    case c.CLEAR_CARDS:
      return [];
    default:
      return state;
  }
}

function cardImages(state = Map(), action) {
  switch (action.type) {
    case c.SET_CARD_IMAGES:
      return state.set(
        action.cardId,
        Map({
          front: action.front,
          back: action.back,
        })
      );
    case c.SET_ERROR:
      return state.set(
        action.cardId,
        Map({
          error: action.error,
        })
      );
    default:
      return state;
  }
}

function imageDisplay(state = Map({ display: false, cardId: "" }), action) {
  switch (action.type) {
    case c.TOGGLE_DISPLAY:
      return state.set("display", !state.get("display"));
    case c.SET_DISPLAY_IMAGE:
      return state.set("cardId", action.cardId);
    case c.CLOSE_IMAGE:
      return state.set("display", false);
    case c.OPEN_IMAGE:
      return state.set("display", true);
    default:
      return state;
  }
}

export default combineReducers({ cards, cardImages, imageDisplay });
